export enum ModuleType {
    None = 0,
    Lead = 1,
    Account = 2,
    Opportunity = 3,
    Case = 8,
    Product = 79,
    Vendor = 99,
    Estimate = 244,
    SalesOrder = 245,
    Location = 248,
    Invoice = 10000004,
    SerialNumbers = 10000045,
    workspace = 355,
}